import { Component, Input } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NoResultComponent } from '../../../../../components/shared/no-result/no-result.component';

@Component({
  selector: 'app-info-match',
  standalone: true,
  imports: [CommonModule, TranslateModule, NoResultComponent],
  templateUrl: './info-match.component.html',
  styleUrl: './info-match.component.scss'
})
export class InfoMatchComponent {

  informationMatch: any;
  titleIncident: string = '';

  urlIMG = environment.urlIMG;

  @Input() set information(data: any) {
    this.informationMatch = data;
  }

  @Input() set title(value: string) {
    this.titleIncident = value;
  }

  constructor() { }
}
